webpackJsonp([6],{

/***/ "2d4O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _constructQuery = __webpack_require__("YNt2");

var _toURLParams = __webpack_require__("7REz");

var _toURLParams2 = _interopRequireDefault(_toURLParams);

var _pages = __webpack_require__("04qB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var withTermsQuery = function withTermsQuery(postType, termsArray, lang, tekstiArray) {
  var items_perpage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
  var orderby = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'date_created';
  var order = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'desc';

  var ITEMS_PER_PAGE = items_perpage;

  var persistFilterStateKey = '_rezultati_filterState';
  var initialFilterState = {
    page: 0,
    total: 0
  };

  var _getInitialFilterState = function _getInitialFilterState() {
    // IMPORTANT: 2. posms izņemts, jo rada nevēlamas situācijas, kad pēc navigācijas
    // iegūstam atfiltrētu sarakstu, jo sessionStorage ir glabājis filterState.

    // NOTE: Primāri pārbaudam location.search parametrus, ja to nav, tad mēģinam
    // iegūt filtru state no sessionStorage vai atgriežam initialFilterState.

    var persistFilterState = Object.assign({}, initialFilterState);

    if (typeof window !== 'undefined') {
      var search = window.location.search;

      if (search && 'URLSearchParams' in window) {
        var searchParams = new URLSearchParams(search);

        searchParams.forEach(function (value, key) {
          if (key === 'page' || key === 'perpage') {
            persistFilterState[key] = parseInt(value, 10);
          } else if (key === 'search') {
            persistFilterState[key] = value;
          } else if (termsArray.includes(key)) {
            if (value !== 'null') {
              persistFilterState[key] = value.split(',');
            }
          } else if (key === 'from' || key === 'to') {
            persistFilterState[key] = parseInt(value, 10);
          }

          if (value === 'null') {
            delete persistFilterState[key];
          }
        });
      }
    }

    return persistFilterState;
  };

  var persistedFilterState = _getInitialFilterState();

  var QUERY = (0, _graphqlTag2.default)((0, _constructQuery.constructQueryForTerms)(postType, termsArray, tekstiArray));

  var queryOptions = {
    options: function options(props) {
      return {
        fetchPolicy: 'cache-first',
        variables: Object.assign({}, {
          lang: lang || 'lv',
          page: persistedFilterState.page || 0,
          perpage: ITEMS_PER_PAGE,
          orderby: orderby,
          order: order,
          search: persistedFilterState.search || props.search || null,
          from: persistedFilterState.from || null,
          to: persistedFilterState.to || null
        }, (0, _constructQuery.constructTermsObj)(termsArray, persistedFilterState))
      };
    },
    props: function props(_ref) {
      var _ref2;

      var data = _ref.data;
      return _ref2 = {}, _defineProperty(_ref2, postType, data[postType]), _defineProperty(_ref2, 'loading', data.loading), _defineProperty(_ref2, 'refetch', data.refetch), _defineProperty(_ref2, 'teksti', data.teksti), _ref2;
    }
  };

  var TermsPage = function (_React$PureComponent) {
    _inherits(TermsPage, _React$PureComponent);

    function TermsPage(props) {
      _classCallCheck(this, TermsPage);

      var _this = _possibleConstructorReturn(this, (TermsPage.__proto__ || Object.getPrototypeOf(TermsPage)).call(this, props));

      _this._refetch = function () {
        try {
          sessionStorage.setItem(persistFilterStateKey, JSON.stringify(_this.state));
        } catch (error) {
          // error
        }

        if (_this.state.search) {
          window.gtag && gtag('event', 'search', {
            event_label: postType,
            search_term: _this.state.search
          });
        }

        var filteredState = _this.removeKeys(_this.state, ['total']);
        var search = (0, _toURLParams2.default)(filteredState);
        var history = _this.props.history;

        history.push({
          search: search
        });

        var refetchVariables = Object.assign({}, {
          lang: _this.props.lang,
          page: _this.state.page,
          perpage: ITEMS_PER_PAGE
        }, (0, _constructQuery.constructTermsObj)(termsArray, _this.state), {
          search: _this.state.search,
          from: _this.state.from,
          to: _this.state.to
        });
        _this.props.refetch(refetchVariables);
      };

      _this.removeKeys = function (obj, keysArr) {
        var filteredObj = {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref3 = _step.value;

            var _ref4 = _slicedToArray(_ref3, 2);

            var key = _ref4[0];
            var value = _ref4[1];

            if (!keysArr.includes(key)) {
              filteredObj[key] = value;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return filteredObj;
      };

      _this._filter = function (event, arg, value) {
        if (event) {
          event.preventDefault();
        }
        var terms = _this.state[arg];

        if (value) {
          if (terms) {
            if ((typeof terms === 'undefined' ? 'undefined' : _typeof(terms)) === 'object') {
              if (terms.indexOf(value) < 0) {
                terms = [].concat(_toConsumableArray(terms), [value]);
              } else {
                terms = terms.filter(function (i) {
                  return i !== value;
                }) || null;
              }
            }
          } else {
            terms = [value];
          }
        } else {
          terms = null;
        }

        // NOTE: Ja nepieciešams deaktivizēt filtru,
        // tukšs masīvs nedarbojas, tāpēc izmantojam null.
        if (Array.isArray(terms) && !terms.length) {
          terms = null;
        }

        _this.setState(function (prevState) {
          return Object.assign({}, prevState, _defineProperty({
            page: 0
          }, arg, terms));
        }, _this._refetch);
      };

      _this._filterByKeywords = function (value) {
        _this.setState(function (prevState) {
          return Object.assign({}, prevState, {
            page: 0,
            search: value
          });
        }, _this._refetch);
      };

      _this._filterByDate = function (from, to) {
        _this.setState(function (prevState) {
          return Object.assign({}, prevState, {
            page: 0,
            from: from,
            to: to
          });
        }, _this._refetch);
      };

      _this._paginate = function (page) {
        if (!Number.isNaN(page) && page !== _this.state.page) {
          _this.setState(function (prevState) {
            return Object.assign({}, prevState, {
              page: page
            });
          }, _this._refetch);
        }
      };

      _this.state = _getInitialFilterState();
      return _this;
    }

    // NOTE: Pagination scroll


    _createClass(TermsPage, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.scrollTo(0, 0);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        window.scrollTo(0, 0);
      }

      // FIXME: event nav nepieciešams, arg un value.. wtf

    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            loading = _props.loading,
            lang = _props.lang,
            teksti = _props.teksti,
            init_page = _props.init_page,
            rest = _objectWithoutProperties(_props, ['loading', 'lang', 'teksti', 'init_page']);

        var data = {
          postType: postType,
          postsData: this.props[postType],
          termsArray: termsArray,
          lang: lang,
          teksti: teksti,
          init_page: init_page,
          filter: this._filter,
          filterState: this.state,
          filterByKeywords: this._filterByKeywords,
          filterByDate: this._filterByDate,
          perpage: ITEMS_PER_PAGE,
          paginate: this._paginate
        };

        return loading ? null : postType === 'pasvaldibas_kontakti' ? _react2.default.createElement(_pages.KontaktiRezultati, _extends({}, data, {
          initialFilterState: rest.initialFilterState
        })) : _react2.default.createElement(_pages.Rezultati, data);
      }
    }]);

    return TermsPage;
  }(_react2.default.PureComponent);

  return (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions))(TermsPage);
};

exports.default = withTermsQuery;

/***/ }),

/***/ "7REz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toURLParams = function toURLParams(json) {
  return json && Object.keys(json).map(function (key) {
    return typeof json[key] !== 'undefined' ? encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) : null;
  }).filter(function (value) {
    return value !== null;
  }).join('&');
};

exports.default = toURLParams;

/***/ }),

/***/ "HZI6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _withTermsQuery = __webpack_require__("2d4O");

var _withTermsQuery2 = _interopRequireDefault(_withTermsQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageDokumenti = function PageDokumenti(props) {
  var PageWithTerms = (0, _withTermsQuery2.default)('dokumenti', ['dokumenti_veidi', 'dokumenti_tags', 'dokumenti_departimenti'], props.lang, ['dokumenti', 'dokumenta_veids', 'visi_dokumentu_veidi', 'departaments', 'visi_departamenti', 'temas', 'visas_temas', 'satur_vardus', 'atpakal', 'talak', 'no', 'dzest']);
  return _react2.default.createElement(PageWithTerms, props);
};

exports.default = PageDokumenti;

/***/ }),

/***/ "YNt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var constructQueryForTerms = exports.constructQueryForTerms = function constructQueryForTerms(type, terms, teksti) {
  var query = '\n    query RezultatiQuery($lang: String!, $page: Int, $perpage: Int, $orderby: [String], $order: [String], $search: String, $from: Int, $to: Int, ' + terms.map(function (term) {
    return '$' + term + ': [String]';
  }).join(', ') + ') {\n      ' + type + '(lang: $lang, page: $page, perpage: $perpage, orderby: $orderby, order: $order, search: $search, from: $from, to: $to, ' + terms.map(function (term) {
    return term + ': $' + term;
  }).join(', ') + ') {\n        page\n        perpage\n        total\n        ' + constructTermsPartial(terms, ['slug', 'name', 'count']) + '\n        posts {\n          _id\n          path\n          title\n          date_created\n          date_modified\n          acf\n          ' + constructTermsPartial(terms, ['slug', 'name']) + '\n        }\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';
  return query;
};

var constructQueryForPostTerms = exports.constructQueryForPostTerms = function constructQueryForPostTerms(terms, teksti) {
  var query = '\n    query PostQuery($lang: String!, $postId: [Int]!) {\n      page(lang: $lang, _id: $postId) {\n        path\n        date_created\n        date_modified\n        title\n        content\n        acf\n        ' + constructTermsPartial(terms) + '\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';

  return query;
};

var constructTermsPartial = exports.constructTermsPartial = function constructTermsPartial(terms) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['name'];

  if (terms && Array.isArray(terms) && terms.length > 0) {
    return '\n      terms {\n        ' + terms.map(function (term) {
      return '\n        ' + term + ' {\n          ' + keys.map(function (key) {
        return key;
      }).join('\n') + '\n        }\n      ';
    }).join('') + '\n      }\n    ';
  }
  return '';
};

var constructTekstiPartial = exports.constructTekstiPartial = function constructTekstiPartial(teksti) {
  if (teksti && Array.isArray(teksti) && teksti.length > 0) {
    return '\n      teksti(lang: $lang, _id: [' + teksti.map(function (id) {
      return '"' + id + '"';
    }).join(', ') + ']) {\n        _id\n        text\n      }\n    ';
  }
  return '';
};

var constructTermsObj = exports.constructTermsObj = function constructTermsObj(terms) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var obj = {};
  terms.forEach(function (term) {
    obj[term] = data && data[term] ? data[term] : null;
  });
  return obj;
};

/***/ })

});


// WEBPACK FOOTER //
// PageDokumenti.9c138f705db57e7e7308.js